<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card class="slider-card-container">
      <div style="position: relative">
        <loading-overlay :loading="loading" />
        <b-row class="justify-content-between px-1 align-items-center">
          <h3>معرض الصور</h3>

          <b-button
            v-can="{ slug: $route.meta.slug, action: 'C' }"
            @click="
              type = 'ADD';
              sliderModal = true;
              imagePreview = null;
            "
            variant="success"
            >إضافة</b-button
          >
        </b-row>
        <hr />
        <div class="container mx-auto">
          <b-row v-if="slides.length > 0" class="justify-content-center">
            <b-col
              xl="4"
              lg="4"
              md="6"
              sm="12"
              v-for="(slide, i) in slides"
              :key="slide.source + slide.id"
            >
              <b-card
                :title="slide.title"
                :img-src="slide.source"
                img-alt="Image"
                img-top
                tag="article"
                class="slider-card"
              >
                <b-card-text>
                  {{ slide.description }}
                </b-card-text>
                <b-row class="justify-content-end px-50 mt-1">
                  <b-button
                    @click="onEditClicked(slide)"
                    variant="primary"
                    class="mx-50"
                    >تعديل</b-button
                  >
                  <b-button
                    @click="onDeleteClicked(slide.id)"
                    variant="flat-danger"
                    >حذف</b-button
                  >
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <div v-else class="text-center p-1" style="opacity: 0.8">
            <h5>
              <feather-icon class="mx-25" icon="AlertTriangleIcon" />

              لا يوجد سجلات حتى الآن
            </h5>
          </div>
        </div>
      </div>
    </b-card>
    <form-modal
      ref="slidesModal"
      title="معلومات الشريحة"
      :loading="loading || working"
      :formSchema="imageSliderFormSchema"
      v-model="sliderModal"
      @confirm="onConfirm"
    >
      <template #source="{ form }">
        <form-image-input
          label="الصورة"
          v-model="form.source"
          id="form-file"
          name="صورة الشريحة"
          :rules="type == 'ADD' ? 'required' : ''"
          withCropper
          :cropAspectRatio="16 / 5"
        />
      </template>
      <template #link_checkbox>
        <b-form-checkbox class="my-1" v-model="withLink"
          >إضافة رابط</b-form-checkbox
        >
      </template>
      <template #link_title="{ form }">
        <form-input
          v-show="withLink"
          label="نص الرابط"
          :rules="withLink ? 'required' : ''"
          v-model="form.link_title"
        />
      </template>
      <template #link_url="{ form }">
        <form-input
          v-show="withLink"
          label="الرابط التشعبي (URL)"
          :rules="withLink ? 'required|url' : ''"
          v-model="form.link_url"
        />
      </template>
    </form-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { mapActions, mapGetters } from "vuex";
import FormModal from "@/components/FormModal.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormImageInput from "@/components/FormImageInput.vue";
import FormInput from "@/components/form-input/index.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BFormCheckbox,
    MinistryBreadcrumbs,
    FormModal,
    LoadingOverlay,
    FormImageInput,
    BCardText,
    FormInput,
  },

  data() {
    return {
      mainTitle: "معرض الصور",
      sliderModal: false,
      filter: "both",
      imagePreview: null,
      withLink: false,
      type: "ADD",
      typeOptions: [
        {
          text: "للمنظمة",
          value: "interior",
        },
        {
          text: "للجمهور",
          value: "exterior",
        },
        {
          text: "للإثنين معاً",
          value: "both",
        },
      ],
      imageSliderFormSchema: {
        source: {
          key: "source",
        },

        title: {
          component: "FormInput",
          key: "title",
          attrs: {
            label: "العنوان",
            rules: "required|max:100",
          },
        },
        description: {
          component: "FormInput",
          key: "description",
          attrs: {
            label: "التفاصيل",
          },
        },
        link_checkbox: {
          key: "link_checkbox",
        },

        link_title: {
          key: "link_title",
        },
        link_url: {
          key: "link_url",
        },
      },
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "معرض الصور",
          active: true,
        },
      ],
    };
  },
  created() {
    this.fetchSlides();
  },
  computed: {
    ...mapGetters("Ministry/Settings/ImageSlider", [
      "loading",
      "working",
      "slides",
    ]),
    slideImage() {
      if (!this.imagePreview) return null;
      else if (typeof this.imagePreview === "string") return this.imagePreview;
      else return URL.createObjectURL(this.imagePreview);
    },
  },
  methods: {
    ...mapActions("Ministry/Settings/ImageSlider", [
      "fetchSlides",
      "editSlide",
      "addSlide",
      "deleteSlide",
    ]),
    setFilter(filter) {
      this.filter = filter;
    },
    async onConfirm(form) {
      if (form.id) {
        if (!form.link_title && !form.link_url) {
          delete form.link_title;
          delete form.link_url;
        }
        await this.editSlide(form);
      } else {
        await this.addSlide(form);
      }
      this.sliderModal = false;
    },

    onEditClicked(slide) {
      this.type = "EDIT";
      this.imagePreview = slide.source;
      this.$refs.slidesModal.init(slide);
      this.sliderModal = true;
    },
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الشريحة ؟", {
          title: "تأكيد حذف الشريحة",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteSlide(id);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.slider-card {
  &.card {
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important;
  }
}
</style>
